<script setup lang="ts">
import { computed, inject, Ref } from 'vue';
import { useSubmitQuoteStore } from '@/store/SubmitQuoteStore';

const dialogRef = inject('dialogRef') as Ref;
const pdfUrl = dialogRef?.value?.options.props.data;

const submitQuoteStore = useSubmitQuoteStore();

const pdfPackage = computed(() => {
  return submitQuoteStore.selectPDF;
});

const statusServer = computed(() => submitQuoteStore.selectIsServerError);
</script>

<template>
  <div v-if="statusServer" class="text-red-500 text-2xl font-bold">{{ $t('common.server_err') }}</div>
  <div v-if="pdfUrl || pdfPackage">
    <embed :src="pdfUrl || pdfPackage" class="pdf-size" />
  </div>
</template>
<style lang="scss" scoped>
.pdf-size {
  width: 100%;
  height: 90vh;
}
</style>
